import './bootstrap'

import {
  createApp,
  h
} from 'vue'
import {
  createInertiaApp,
  Head,
  Link
} from '@inertiajs/vue3'
import {
  resolvePageComponent
} from 'laravel-vite-plugin/inertia-helpers'
import {
  ZiggyVue
} from '../../vendor/tightenco/ziggy/dist/vue.m'
import TextClamp
  from 'vue3-text-clamp'

import dayjs
  from 'dayjs'
import dayJsPluginRelativeTime
  from 'dayjs/plugin/relativeTime'
import dayJsPluginUtc
  from 'dayjs/plugin/utc'
import dayJsPluginTimezone
  from 'dayjs/plugin/timezone'
import dayJsPluginAdvancedFormat
  from 'dayjs/plugin/advancedFormat'
import tailwindColors
  from '../../colors'
import { i18nVue } from 'laravel-vue-i18n'
import { register } from 'swiper/element/bundle'
// Register swiper element
register()

dayjs.extend(dayJsPluginRelativeTime)
dayjs.extend(dayJsPluginUtc)
dayjs.extend(dayJsPluginTimezone)
dayjs.extend(dayJsPluginAdvancedFormat)

const appName = import.meta.env.VITE_APP_NAME || 'Classward'

import.meta.glob(['../images/**', '../fonts/**'])

window.colors = tailwindColors

let app = createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) =>
    resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob('./Pages/**/*.vue', { eager: false })
    ),
  setup ({
    el,
    App,
    props,
    plugin
  }) {
    let inertiaApp = createApp({ render: () => h(App, props) })

    inertiaApp.config.globalProperties.dayjs = dayjs
    inertiaApp.config.globalProperties.colors = tailwindColors

    inertiaApp
      .use(plugin)
      .use(ZiggyVue, Ziggy)
      .use(TextClamp)
      .use(i18nVue, {
        resolve: async lang => {
          const langs = import.meta.glob('../../lang/*.json');
          return await langs[`../../lang/php_${lang}.json`]();
        }
      })
      .mixin({ methods: { route } })
      .mixin({
        methods: {
          getImageUrl (name, ext) {
            return new URL(`../images/${name}`, import.meta.url)
              .href
          },
        },
      })

      .component('Head', Head)
      .component('Link', Link)

    inertiaApp.mount(el)

    return inertiaApp

  },
  progress: {
    color: '#4B5563',
  },
})
